/**
 * コメント候補テンプレート一覧取得 API を提供する。
 * テーブル未作成の環境では空配列を返し、一覧画面の描画を継続する。
 */

import type { RunToDatabase } from '@/types'
import { selectCommentCandidates } from '@pkg/database-portfolio'

/**
 * コメント候補テンプレート一覧を取得する。
 * @param params DB 読み取り関数を受け取る。
 * @returns コメント候補テンプレート一覧を返す。
 */
export const getCommentCandidates = async ({
  readFromDatabase,
}: {
  readonly readFromDatabase: RunToDatabase
}) => {
  return await readFromDatabase((database) =>
    selectCommentCandidates({ database }),
  )
}
